module.exports = __webpack_public_path__ + "img/clipboard.a754c187.svg";